import { createRequestTypes } from '../utils';

export const FETCH_SUBSTANCE_TOX_PROFILES = createRequestTypes('substanceToxProfile/FETCH_SUBSTANCE_TOX_PROFILE');
export const DELETE_SUBSTANCE_TOX_PROFILE = createRequestTypes('substanceToxProfile/DELETE_SUBSTANCE_TOX_PROFILE');
export const SAVE_SUBSTANCE_TOX_PROFILE = createRequestTypes('substanceToxProfile/SAVE_SUBSTANCE_TOX_PROFILE');
